import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import React from 'react';
import { useGetAllFormSubmissions } from '../../../services/react-query/form_submissions/useGetAllFormSubmissions';
import _ from 'lodash';
import { listPageTableRowStyling } from '../../../styles/sxStyling';
import { modalStyles } from '../../../styles/modalStyles';
import { Loading } from '../../../uikit';
import { FormTemplateLink } from '../../../types/FormTemplate';
import { humanizeTimestamp } from '../../../utility/dateUtils';
import AppLink from '../AppLink/AppLink';

interface IFormSubmissionsModalProps {
  isOpen: boolean;
  onClose: () => void;
  formTemplateLink?: FormTemplateLink | null;
}

export default function FormSubmissionsModal({ isOpen, onClose, formTemplateLink }: IFormSubmissionsModalProps) {
  const { data, isLoading, isError } = useGetAllFormSubmissions({
    params: {
      filters: {
        event_form_template: formTemplateLink?.uuid,
      }
    },
    enabled: !!formTemplateLink,
  });

  if (!formTemplateLink) return null;

  return (
    <Dialog open={isOpen} onClose={onClose} fullWidth maxWidth="lg">
      <DialogTitle>Form Submissions</DialogTitle>
      <DialogContent dividers>
        {isLoading ? (
          <Loading />
        ) : isError ? (
          <Box sx={modalStyles.errorBox}>Failed to load form submissions.</Box>
        ) : (
          <Box sx={modalStyles.container}>
            <Table sx={{ mb: 4 }}>
              <TableHead>
                <TableRow>
                  <TableCell>Contact Name</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Last Reminder Sent</TableCell>
                  <TableCell>Submitted</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {_.map(data?.data, (submission) => (
                  <TableRow key={submission.uuid} sx={{ ...listPageTableRowStyling }}>
                    <TableCell>
                      {
                        _.includes(['in_progress', 'submitted'], submission.status) ?
                          <AppLink to={`/form-submissions/${submission.uuid}`}>{submission.contact_display_name}</AppLink> :
                          submission.contact_display_name
                      }
                    </TableCell>
                    <TableCell>{_.startCase(submission.status)}</TableCell>
                    <TableCell>{humanizeTimestamp(submission.invite_sent_at)}</TableCell>
                    <TableCell>{humanizeTimestamp(submission.submitted_at)}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
